import moment from 'moment'

interface WeightSpec {
    format: string
    match: RegExp
}

export const timeScaleWeighted = (time: string, range: string[]): string => {
    if (range.length !== 2) {
        return classes([])
    }

    const date: moment.Moment = moment(time)

    // exclude ms/s timings in response time distribution
    if (date.format('YYYY') === '1970') {
        return classes([])
    }

    const start: moment.Moment = moment(range[0])
    const end: moment.Moment = moment(range[1])
    const duration: moment.Duration = moment.duration(end.diff(start))

    if (duration.asDays() > 10) {
        return timeScaleWeightedClasses(
            date,
            { format: 'DD HH:mm', match: /(01|15) 00:00/ },
            { format: 'DD HH:mm', match: /(05|10|20|25) 00:00/ },
        )
    }

    if (duration.asDays() > 5) {
        return timeScaleWeightedClasses(
            date,
            { format: 'DD HH:mm', match: /(12|24) 00:00/ },
            { format: 'DD HH:mm', match: /(03|06|09|15|18|21|27|30) 00:00/ },
        )
    }

    if (duration.asDays() > 2) {
        return timeScaleWeightedClasses(date, { format: 'HH:mm', match: /25:00/ }, { format: 'HH:mm', match: /00:00/ })
    }

    if (duration.asHours() > 16) {
        return timeScaleWeightedClasses(date, { format: 'HH:mm', match: /00:00/ }, { format: 'HH:mm', match: /12:00/ })
    }

    if (duration.asMinutes() > 240) {
        return timeScaleWeightedClasses(
            date,
            { format: 'HH:mm', match: /(00|12):00/ },
            { format: 'HH:mm', match: /(03|06|09|15|18|21):00/ },
        )
    }

    if (duration.asMinutes() > 120) {
        return timeScaleWeightedClasses(date, { format: 'mm', match: /00/ }, { format: 'mm', match: /30/ })
    }

    return timeScaleWeightedClasses(date, { format: 'mm', match: /00/ }, { format: 'mm', match: /(15|30|45)/ })
}

const timeScaleWeightedClasses = (date: moment.Moment, high: WeightSpec, medium: WeightSpec): string => {
    if (date.format(high.format).match(high.match)) {
        return classes(['weight-high'])
    }

    if (date.format(medium.format).match(medium.match)) {
        return classes(['weight-medium'])
    }

    return classes([])
}

const classes = (classNames: string[]): string => ['weighted-tick', ...classNames].join(' ')
